export enum IUpdatePasswordActionTypes {
	NEW_PASSWORD_IS_INVALID = '@@resetPassword/NEW_PASSWORD_IS_INVALID',
	NEW_PASSWORD_IS_VALID = '@@resetPassword/NEW_PASSWORD_IS_VALID',
	UPDATE_PASSWORD_FAILED = '@@resetPassword/UPDATE_PASSWORD_FAILED',
	UPDATE_PASSWORD_FROM_EMAIL = '@@resetPassword/UPDATE_PASSWORD_FROM_EMAIL',
	UPDATE_PASSWORD_FROM_PREVIOUS = '@@resetPassword/UPDATE_PASSWORD_FROM_PREVIOUS',
	UPDATE_PASSWORD_SUCCEED = '@@resetPassword/UPDATE_PASSWORD_SUCCEED',
}

export interface IUpdatePasswordState {
	readonly isNewPwdValid: boolean;
	readonly isUpdateSucceed: boolean;
	readonly newpwd: string;
	readonly newPwdInvalidMsg: string;
	readonly oldpwd: string;
	readonly token: string;
	readonly updateIsErrorMsg: string;
}
